import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomTextField from "../CustomComponents/CustomTextField";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef } from "react";
import { ReShedulementReducerAction } from "../Store/ReSchedulement/ReSchedulementReducer";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import axios from "axios";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import { Box } from "@mui/system";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { UpdateRounded } from "@mui/icons-material";
import { useState } from "react";
import RevisedRepaymentDialog from "./RevisedRepaymentDialog";
import {
  EmiTenureModel,
  ProcessScheduleHistoryModel,
  amountFormatter,
  convertEmiToNumber,
  earlierReschedulementGridData,
  getSelectedBranchCode,
  processChangeHeaderModel,
} from "./ReSchedulementHelper";
import dayjs from "dayjs";
import EmiTenureDialog from "./EmiTenureDialog";
import ReSchedulementConfirmDialog from "./ReSchdulementConfirmDialog";
import CustomConfirmationDialog from "../CustomComponents/CustomConfirmationDialog";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import store from "../Store";

const ReSchedulementPage = (props) => {
  const dispatch = useDispatch();
  const [dropDownValue, setDropdownValue] = useState("Change EMI");
  const [openRevisedDialog, setOpenRevisedDialog] = useState(false);
  const [openEmiAlertDialog, setopenEmiAlertDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [reschduleByDisable, setReschduleByDisable] = useState(true);
  const [effectiveDateValidDateError, setEffectiveDateDateValidDateError] =
    useState(false);
  const [rescheduleByValue, setRescheduleByValue] = useState([]);
  const [suggestEmiValue, setSuggestEmiValue] = useState("");
  const [suggestTenureValue, setSuggestTenureValue] = useState("");
  const [dialogFor, setDialogFor] = useState("");

  const [informationDialogOpen, setInformationDialogOpen] = useState();
  const [informationDialogMsg, setInformationDialogMsg] = useState("");
  const [tenureAlertDlgMsgState, setTenureAlertDlgMsgState] = useState(false);
  const [accoutnCloseInformation, setAccoutnCloseInformation] = useState(false);
  const [loanClosed, setLoanClosed] = useState();
  const [emiHasError, setEmiHasError] = useState(false);
  const [tenureHasError, setTenureHasError] = useState(false);

  const [currentValueHasError, setCurrentValueHasError] = useState(false);

  const [branch, setBranch] = useState("");
  const [appNum, setAppNum] = useState("");

  const [historyValues, setHistoryValues] = useState(null);
  const [amortValues, setAmortValues] = useState(null);

  const [dropValue, setDropValue] = useState("");

  const [ecd, setEcd] = useState(null);
  const [fedd, setfedd] = useState(null);

  const [viewAmortBeforeSave, setViewAmortBeforeSave] = useState(false);
  const [yesButtonDisableHandler, setYesButtonDisableHandler] = useState(false);
  //Snackbar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const filterValues = useSelector(
    (state) => state.reSchedulement.filterValues
  );

  const valueIsValid = useSelector(
    (state) => state.reSchedulement.valueIsValid
  );

  const touchHandler = useSelector(
    (state) => state.reSchedulement.touchHandler
  );

  const userName = useSelector((state) => state.branch.userName);

  const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  //field access
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Reschedulement Effective Date Back Count"] &&
        new Date(
          paramValues["Reschedulement Effective Date Back Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Reschedulement Effective Date Back Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.reSchedulementEffectiveDate &&
        fieldAccessMap.reSchedulementEffectiveDateBackCount
          ? Number(
              paramValues["Reschedulement Effective Date Back Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Reschedulement Effective Date Future Count"] &&
        new Date(
          paramValues["Reschedulement Effective Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Reschedulement Effective Date Future Count"][
            "paramEffEndDate"
          ]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.reSchedulementEffectiveDate &&
        fieldAccessMap.reSchedulementEffectiveDateFutureCount
          ? Number(
              paramValues["Reschedulement Effective Date Future Count"][
                "paramValue"
              ]
            )
          : Number(0);
    }
  }

  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationNumTouched && !valueIsValid.applicationNumIsValid;
  const effectiveDateHasError =
    touchHandler.effectiveDateTouched && !valueIsValid.effectiveDateIsValid;
  const revisedTenureHasError =
    touchHandler.revisedTenureTouched && !valueIsValid.revisedTenureIsValid;
  const revisedEmiHasError =
    touchHandler.revisedEmiTouched && !valueIsValid.revisedEmiIsValid;
  const reasonHasError =
    touchHandler.reasonTouched && !valueIsValid.reasonIsValid;

  useEffect(() => {
    getRescheduleByValue();
    dispatch(ReShedulementReducerAction.resetTouchHandlers());
    dispatch(ReShedulementReducerAction.updateBranchIsTouched(false));
    const branchArr = GetBranchDetails();
    dispatch(ReShedulementReducerAction.updateBranchArray(branchArr));
    dispatch(
      ReShedulementReducerAction.updateApplicationNumberIsTouched(false)
    );
  }, []);
  const getRescheduleByValue = async () => {
    const nachLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD014",
    });
    const rescheduleByValueMap = nachLovValues.data["Reschedule By"].map(
      (type) => {
        return {
          key: type.lovOrder,
          value: type.lovValues,
          text: type.lovValues,
        };
      }
    );
    setRescheduleByValue(rescheduleByValueMap);
  };
  //Escape Key Implementation
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const saveRef = useRef(null);
  const historyRef = useRef(null);
  const clearRef = useRef(null);
  const okRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.addEventListener("keydown", onKeyUnmountEventHandler);
      window.addEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "reSchedulement",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = { cancelRef: cancelRef, historyRef: historyRef };
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      closeSaveConfirmDialog();
    } else if (event.ctrlKey) {
      if (charCode === "y") {
        yesRef.current.click();
      } else if (charCode === "s") {
        saveRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "i") {
        dispatch(ReShedulementReducerAction.updateEffectiveDate(date));
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        dispatch(ReShedulementReducerAction.updateEffectiveDate(date));
      } else if (charCode === "k") {
        okRef.current.click();
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "reSchedulement",
          })
        );
      }
    }
  };
  const branchOnChangeHandler = async (value) => {
    dispatch(ReShedulementReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      if (value.label !== branch) {
        setBranch(value.label);
        try {
          const branchCodeValue = getSelectedBranchCode(value.label);
          const response = await axios.post(
            "/losCustomer/getLosAppNumByStatus",
            {
              branch: value.label,
              status: [
                "Disbursement Completed",
                "Disbursed",
                "Requested",
                "Loan Closed",
              ],
              branchCode: branchCodeValue,
            }
          );
          resetOnBranchChange();
          resetValues();
          dispatch(
            ReShedulementReducerAction.updateApplicationArray(
              response.data.sort()
            )
          );
        } catch (error) {
          throw Error(error);
        }
      }
    } else {
      setBranch("");
      resetOnBranchChange();
      resetValues();
      dispatch(ReShedulementReducerAction.updateBranchValue(null));
      dispatch(ReShedulementReducerAction.updateApplicationArray([]));
      setReschduleByDisable(true);
    }
  };
  const onOkButtonClick = () => {
    setAccoutnCloseInformation(false);
  };
  const handleClose = () => {
    setInformationDialogOpen(false);
    setInformationDialogMsg("");
    setTenureAlertDlgMsgState(false);
  };
  const handleOk = () => {
    dispatch(ReShedulementReducerAction.resetRevisedValues());
    setSuggestEmiValue("");
    setSuggestTenureValue("");
    setDropdownValue(dropValue);
    setTenureHasError(false);
    setEmiHasError(false);
    setInformationDialogOpen(false);
    setInformationDialogMsg("");
    setTenureAlertDlgMsgState(false);
  };

  const resetOnBranchChange = () => {
    setAppNum("");
    dispatch(ReShedulementReducerAction.updateApplicationValue(null));
    setReschduleByDisable(true);
  };

  const applicationNumOnChangeHandler = async (value) => {
    dispatch(ReShedulementReducerAction.updateApplicationValue(value));
    if (value && value !== "") {
      if (value.label !== appNum) {
        try {
          setAppNum(value);
          resetValues();
          const branchCodeValue = getSelectedBranchCode(branch);
          const response = await axios.post("/reschedulement/getCustomerData", {
            applicationNum: value,
            branch: branch,
            branchCode: branchCodeValue,
          });
          let record = response.data;
          let filterValues = {};
          filterValues.branch = branch;
          filterValues.applicationNum = value;
          filterValues.customerName = record.customerName;
          filterValues.customerId = record.customerId;
          filterValues.loanStatus = record.loanStatus;
          if (record.loanStatus) {
            setAccoutnCloseInformation(true);
            setLoanClosed(true);
          } else {
            setLoanClosed(false);
            filterValues.loanBalance = record.loanBalance;
            filterValues.rateOfInterest = record.roi;
            filterValues.currentEmi = record.currentEmi;
            filterValues.currentTenure = record.currentTenure;
            setReschduleByDisable(false);
          }
          dispatch(ReShedulementReducerAction.updateFilterValues(filterValues));
          setHistoryValues(record.reSchedulementList);
        } catch (error) {
          throw Error(error);
        }
      }
    } else {
      setAppNum("");
      setReschduleByDisable(true);
      setHistoryValues(null);
      setAmortValues(null);
      resetValues();
    }
  };

  const resetValues = () => {
    dispatch(ReShedulementReducerAction.resetFilterValues());
    dispatch(ReShedulementReducerAction.resetRevisedValues());
    dispatch(ReShedulementReducerAction.updateReasonValue(""));
    dispatch(ReShedulementReducerAction.updateReasonIsTouched(false));
    setHistoryValues(null);
    setDropdownValue("Change EMI");
    setSuggestEmiValue("");
    setSuggestTenureValue("");
    setTenureHasError(false);
    setEmiHasError(false);
  };

  const closeRevisedDialog = (v) => {
    setOpenRevisedDialog(v);
  };

  const closeEmiAlertDialog = () => {
    dispatch(ReShedulementReducerAction.resetRevisedValues());
    setopenEmiAlertDialog(false);
  };

  const handleEmiAlertDialogOk = () => {
    dispatch(
      ReShedulementReducerAction.updateRevisedTenureValue(suggestTenureValue)
    );
    dispatch(ReShedulementReducerAction.updateRevisedEMIValue(suggestEmiValue));
    setopenEmiAlertDialog(false);
  };

  const closeSaveConfirmDialog = (IsClear) => {
    setOpenConfirmDialog(false);
    if (IsClear) {
      clearButtonHandler();
    }
  };

  const handleSaveDialogOk = async () => {
    setYesButtonDisableHandler(true);
    try {
      const response = await axios.post(
        "/reschedulement/insertProcessAndScheduledHistory",
        ProcessScheduleHistoryModel(filterValues, userName)
      );
      let record = response.data;
      setHistoryValues(record);
      setConfirmMessage("Application is ReScheduled Successfully!");
      setMessageType("info");
      setYesButtonDisableHandler(false);
    } catch (error) {
      throw Error(error);
    }
  };

  const formAlertMsgForGreaterTenure = (originalTenureVal) => {
    let msgValue =
      `New Tenure Exceeds Application Original Tenure ` +
      originalTenureVal +
      ` (In Months)`;
    setInformationDialogMsg(msgValue);
    setTenureAlertDlgMsgState(true);
    setInformationDialogOpen(true);
  };

  const getEmi = async (value, loanBalance) => {
    const loanBal = loanBalance ? loanBalance : filterValues.loanBalance;
    if (filterValues.currentTenure !== Number(value)) {
      setCurrentValueHasError(false);
      try {
        const tenureValue = value <= 360 ? value : 360;
        const response = await axios.post(
          "/reschedulement/getEmi",
          EmiTenureModel(
            loanBal,
            convertEmiToNumber(filterValues.revisedEmi),
            tenureValue,
            filterValues.rateOfInterest,
            filterValues.applicationNum,
            filterValues.effectiveDate
              ? dayjs(filterValues.effectiveDate).format("M/D/YYYY")
              : null
          )
        );
        let record = response.data;
        setEcd(record.ecd);
        setfedd(record.fedd);
        if (Number(record.combinedTenure) > Number(record.originalTenure)) {
          formAlertMsgForGreaterTenure(record.originalTenure);
        } else if (tenureValue !== record.tenure.toString() && !loanBalance) {
          setDialogFor("tenure");
          setSuggestTenureValue(record.tenure);
          setSuggestEmiValue(amountFormatter(record.emiAmt));
          setopenEmiAlertDialog(true);
        } else {
          dispatch(
            ReShedulementReducerAction.updateRevisedTenureValue(tenureValue)
          );
          dispatch(
            ReShedulementReducerAction.updateRevisedEMIValue(
              amountFormatter(record.emiAmt)
            )
          );
        }
        dispatch(ReShedulementReducerAction.updateRevisedEmiIsTouched(false));
      } catch (error) {
        throw Error(error);
      }
    } else {
      setDialogFor("tenure");
      setCurrentValueHasError(true);
      setopenEmiAlertDialog(true);
    }
  };

  const getTenure = async (emiValue, loanBalance) => {
    const loanBal = loanBalance ? loanBalance : filterValues.loanBalance;
    if (filterValues.currentEmi !== Number(emiValue)) {
      try {
        const response = await axios.post(
          "/reschedulement/getTenure",
          EmiTenureModel(
            loanBal,
            convertEmiToNumber(emiValue),
            filterValues.revisedTenure,
            filterValues.rateOfInterest,
            filterValues.applicationNum,
            filterValues.effectiveDate
              ? dayjs(filterValues.effectiveDate).format("M/D/YYYY")
              : null
          )
        );
        let record = response.data;
        setEcd(record.ecd);
        setfedd(record.fedd);
        if (Number(record.combinedTenure) > Number(record.originalTenure)) {
          formAlertMsgForGreaterTenure(record.originalTenure);
        } else if (
          convertEmiToNumber(emiValue) !== record.emiAmt &&
          !loanBalance
        ) {
          setDialogFor("emi");
          setSuggestTenureValue(record.tenure);
          setSuggestEmiValue(amountFormatter(record.emiAmt));
          setopenEmiAlertDialog(true);
          setCurrentValueHasError(false);
        } else {
          dispatch(
            ReShedulementReducerAction.updateRevisedTenureValue(record.tenure)
          );
          dispatch(
            ReShedulementReducerAction.updateRevisedEMIValue(
              amountFormatter(record.emiAmt)
            )
          );
        }
        dispatch(
          ReShedulementReducerAction.updateRevisedTenureIsTouched(false)
        );
      } catch (error) {
        throw Error(error);
      }
    } else {
      setDialogFor("emi");
      setCurrentValueHasError(true);
      setopenEmiAlertDialog(true);
    }
  };

  const clearButtonHandler = () => {
    resetValues();
    resetOnBranchChange();
    dispatch(ReShedulementReducerAction.updateBranchValue(null));
    dispatch(ReShedulementReducerAction.updateBranchIsTouched(false));
    dispatch(
      ReShedulementReducerAction.updateApplicationNumberIsTouched(false)
    );
    dispatch(ReShedulementReducerAction.updateApplicationArray([]));
    setBranch("");
  };

  const validData = () => {
    return (
      valueIsValid.branchIsValid &&
      valueIsValid.applicationNumIsValid &&
      valueIsValid.effectiveDateIsValid &&
      valueIsValid.revisedTenureIsValid &&
      valueIsValid.revisedEmiIsValid &&
      valueIsValid.reasonIsValid &&
      !effectiveDateValidDateError
    );
  };

  const saveButtonHandler = async () => {
    if (validData()) {
      setOpenConfirmDialog(true);
      setConfirmMessage("Are you sure want to ReSchedule?");
      setMessageType("confirm");
    } else {
      dispatch(ReShedulementReducerAction.updateBranchIsTouched(true));
      dispatch(
        ReShedulementReducerAction.updateApplicationNumberIsTouched(true)
      );
      if (!reschduleByDisable) {
        dispatch(ReShedulementReducerAction.updateReasonIsTouched(true));
        if (dropDownValue === "Change EMI") {
          filterValues.revisedEmi !== ""
            ? setEmiHasError(false)
            : setEmiHasError(true);
        } else {
          filterValues.revisedTenure !== ""
            ? setTenureHasError(false)
            : setTenureHasError(true);
        }
      }
    }
  };

  const loadRepaymentSchedule = async () => {
    await axios
      .post("/reschedulement/getAmortData", {
        applicationNum: filterValues.applicationNum,
        requestedDate: null,
        processHeader:
          filterValues.revisedEmi !== "" && filterValues.revisedTenure !== ""
            ? processChangeHeaderModel(filterValues, ecd, fedd)
            : null,
      })
      .then((response) => {
        setViewAmortBeforeSave(
          filterValues.revisedEmi !== "" && filterValues.revisedTenure !== ""
        );
        setAmortValues(response.data);
      });
  };

  const getLoanBalanceBasedOnEffectiveDate = async (value) => {
    if (value !== null && value !== "") {
      await axios
        .post("/reschedulement/getLoanBalance", {
          applicationNum: filterValues.applicationNum,
          requestedDate: dayjs(value).format("M/D/YYYY"),
        })
        .then((response) => {
          const record = response.data;
          dispatch(
            ReShedulementReducerAction.updateLoanBalance(record.loanBalance)
          );
          dispatch(ReShedulementReducerAction.updateCurrentEmi(record.emiAmt));
          dispatch(
            ReShedulementReducerAction.updateCurrentTenure(record.tenure)
          );
          if (
            filterValues.revisedEmi !== "" &&
            filterValues.revisedTenure !== ""
          ) {
            if (!reschduleByDisable && dropDownValue === "Change EMI") {
              getTenure(filterValues.revisedEmi, record.loanBalance);
            } else if (
              !reschduleByDisable &&
              dropDownValue === "Change Tenure"
            ) {
              getEmi(filterValues.revisedTenure, record.loanBalance);
            }
          }
        });
    } else {
      dispatch(ReShedulementReducerAction.updateEffectiveDateIsTouched(true));
    }
  };

  return (
    <>
      <AccordianContainer
        id="accord"
        title="Re-Schedulement"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={!props.disabled}
                autoCompleteValues={filterValues.branchArray}
                value={filterValues.branch}
                disabled={props.disabled}
                onChange={(event, newValue) => {
                  branchOnChangeHandler(newValue);
                  dispatch(
                    ReShedulementReducerAction.updateBranchIsTouched(true)
                  );
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                label="Application Number"
                required={!props.disabled}
                disabled={props.disabled}
                autoCompleteValues={filterValues.applicationArray}
                value={filterValues.applicationNum}
                onChange={(event, newValue) => {
                  applicationNumOnChangeHandler(newValue);
                  dispatch(
                    ReShedulementReducerAction.updateApplicationNumberIsTouched(
                      true
                    )
                  );
                }}
              />
              {applicationHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Customer ID"
                variant="standard"
                placeholder="Enter Customer ID"
                disabled={true}
                value={filterValues.customerId}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Applicant Name"
                variant="standard"
                placeholder="Enter Applicant Name"
                disabled={true}
                value={filterValues.customerName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                label="Effective Date"
                variant="standard"
                value={filterValues.effectiveDate}
                required={!reschduleByDisable}
                disabled={reschduleByDisable}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateFromValue
                )}
                minDate={new Date().setDate(
                  new Date().getDate() - minDateFromValue
                )}
                onChange={(value) => {
                  dispatch(
                    ReShedulementReducerAction.updateEffectiveDate(value)
                  );
                  if (value !== null && value !== undefined && value !== "") {
                    new Date(value).toDateString() !== "Invalid Date" &&
                    new Date(value) >= currentDate &&
                    new Date(value).toLocaleDateString().slice(-4) <= "2055"
                      ? setEffectiveDateDateValidDateError(false)
                      : setEffectiveDateDateValidDateError(true);
                  } else {
                    setEffectiveDateDateValidDateError(true);
                  }
                  getLoanBalanceBasedOnEffectiveDate(value);
                }}
              />
              {(effectiveDateValidDateError || effectiveDateHasError) && (
                <p className="error">Please Enter Valid Date</p>
              )}
            </Grid>
            <Grid id item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDropDown
                label="Reschedule By"
                variant="standard"
                defaultValue={"Change EMI"}
                value={dropDownValue}
                disabled={loanClosed ? true : reschduleByDisable}
                dropDownValue={rescheduleByValue}
                onChange={(event) => {
                  if (
                    filterValues.revisedEmi !== "" ||
                    filterValues.revisedTenure !== ""
                  ) {
                    setDropValue(event.target.value);
                    setInformationDialogMsg(
                      "Revised EMI and Revised Tenure will be Reset to Default ?"
                    );
                    setTenureAlertDlgMsgState(false);
                    setInformationDialogOpen(true);
                  } else {
                    dispatch(ReShedulementReducerAction.resetRevisedValues());
                    setSuggestEmiValue("");
                    setSuggestTenureValue("");
                    setDropdownValue(event.target.value);
                    setTenureHasError(false);
                    setEmiHasError(false);
                    setTenureAlertDlgMsgState(false);
                    setInformationDialogOpen(false);
                    setInformationDialogMsg("");
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Loan Balance (₹)"
                variant="standard"
                placeholder="Enter Loan Balance"
                disabled={true}
                value={amountFormatter(filterValues.loanBalance)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Rate Of Interest (%)"
                variant="standard"
                placeholder="Enter Rate Of Interest"
                disabled={true}
                value={filterValues.rateOfInterest}
              />
            </Grid>
            <Grid item xs={5.85} sm={2.95} md={1.95} lg={1.475} xl={1.475}>
              <CustomTextField
                type="text"
                label="Current EMI (₹)"
                variant="standard"
                placeholder="Enter Current EMI"
                disabled={true}
                value={amountFormatter(filterValues.currentEmi)}
              />
            </Grid>
            <Grid>
              <h4 style={{ position: "relative", top: "15%" }}> / </h4>
              <h4 style={{ position: "relative", top: "17.5%" }}> / </h4>
            </Grid>
            <Grid item xs={5.85} sm={2.95} md={1.95} lg={1.475} xl={1.475}>
              <CustomTextField
                type="text"
                variant="standard"
                placeholder="Enter Revised EMI"
                onKeyDown={(e) => {
                  const ASCIICode = e.which ? e.which : e.keyCode;
                  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
                    e.preventDefault();
                  }
                }}
                disabled={
                  loanClosed
                    ? true
                    : reschduleByDisable || dropDownValue !== "Change EMI"
                }
                required={!reschduleByDisable && dropDownValue === "Change EMI"}
                label={"Revised EMI (₹)"}
                value={filterValues.revisedEmi}
                onChange={(event) => {
                  const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
                  if (!regex.test(event.target.value)) {
                    dispatch(
                      ReShedulementReducerAction.updateRevisedEMIValue(
                        event.target.value
                      )
                    );
                    dispatch(
                      ReShedulementReducerAction.updateRevisedEmiIsTouched(true)
                    );
                    setEmiHasError(false);
                    if (event.target.value === "") {
                      dispatch(
                        ReShedulementReducerAction.updateRevisedTenureValue("")
                      );
                    }
                  }
                }}
                onBlur={(event) => {
                  if (
                    filterValues.applicationNum &&
                    filterValues.revisedEmi !== ""
                  ) {
                    getTenure(event.target.value);
                  }
                }}
              />
              {(revisedEmiHasError || emiHasError) && (
                <p className="error">Enter Valid Revised EMI</p>
              )}
            </Grid>
            <Grid item xs={5.85} sm={2.9} md={1.95} lg={1.475} xl={1.475}>
              <CustomTextField
                type="number"
                label="Balance Tenure"
                variant="standard"
                placeholder="Enter Balance Tenure"
                disabled={true}
                value={filterValues.currentTenure}
              />
            </Grid>
            <Grid>
              <h4 style={{ position: "relative", top: "15%" }}> / </h4>
              <h4 style={{ position: "relative", top: "17.5%" }}> / </h4>
            </Grid>
            <Grid item xs={5.85} sm={2.9} md={1.95} lg={1.475} xl={1.475}>
              <CustomTextField
                type="number"
                variant="standard"
                label={"Revised Tenure"}
                placeholder="Enter Revised Tenure"
                disabled={loanClosed ? true : dropDownValue === "Change EMI"}
                required={!reschduleByDisable && dropDownValue !== "Change EMI"}
                value={filterValues.revisedTenure}
                onKeyDown={(e) => {
                  e.key === "." && e.preventDefault();
                }}
                onChange={(e) => {
                  if (e.target.value >= 0) {
                    if (e.target.value === "") {
                      dispatch(
                        ReShedulementReducerAction.updateRevisedEMIValue("")
                      );
                    }
                    dispatch(
                      ReShedulementReducerAction.updateRevisedTenureValue(
                        e.target.value
                      )
                    );
                    dispatch(
                      ReShedulementReducerAction.updateRevisedTenureIsTouched(
                        true
                      )
                    );
                    setTenureHasError(false);
                  }
                }}
                onBlur={(event) => {
                  if (filterValues.applicationNum && event.target.value > 0) {
                    getEmi(event.target.value);
                  }
                }}
              />
              {(revisedTenureHasError || tenureHasError) && (
                <p className="error"> Enter Valid Revised Tenure</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                type="text"
                label="Reason for Reschedulement"
                variant="standard"
                placeholder="Enter Reason For Reschedulement"
                value={filterValues.reason}
                required={!reschduleByDisable}
                disabled={loanClosed ? true : reschduleByDisable}
                autoCompleteValues={["Prepayments", "Customer Request"]}
                onChange={(event, value) => {
                  dispatch(ReShedulementReducerAction.updateReasonValue(value));
                  dispatch(
                    ReShedulementReducerAction.updateReasonIsTouched(true)
                  );
                }}
              />
              {reasonHasError && (
                <p className="error">Enter Valid Reason for Reschedulement</p>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+S" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem", fontWeight: "bold" }}
                onClick={saveButtonHandler}
                disabled={loanClosed}
                ref={saveRef}
              >
                Save
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                  fontWeight: "bold",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={clearButtonHandler}
                ref={clearRef}
              >
                Clear
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+H" placement="right">
              <Button
                variant="contained"
                type="submit"
                disabled={reschduleByDisable}
                sx={{ height: "2rem" }}
                onClick={() => {
                  setOpenRevisedDialog(true);
                  loadRepaymentSchedule();
                }}
                ref={historyRef}
              >
                <UpdateRounded />
              </Button>
            </Tooltip>
          </Box>
        </Box>
      </AccordianContainer>
      <Box
        sx={{
          marginTop: "8px",
          marginBottom: "8px",
          justifyContent: "center",
        }}
      >
        <AccordianContainer
          id="accord"
          title="Earlier Re-Schedulement"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <CustomDataGrid
            noDataMessage="No Data"
            rows={
              historyValues !== null
                ? historyValues.map((item, index) => ({
                    id: index + 1,
                    ...item,
                  }))
                : []
            }
            columns={earlierReschedulementGridData}
            pageSize={10}
            pageSizeOptions={[20]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.reScheduleKey}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
        </AccordianContainer>
        <Snackbar
          open={alert}
          autoHideDuration={3000}
          anchorOrigin={{ vertical, horizontal }}
          onClose={() => setAlert(false)}
        >
          <Alert
            onClose={() => setAlert(false)}
            severity={alertType}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Box>
      <RevisedRepaymentDialog
        openDialog={openRevisedDialog}
        filterValues={filterValues}
        amortValues={amortValues}
        viewAmortBeforeSave={viewAmortBeforeSave}
        closeDialog={closeRevisedDialog}
        ecd={ecd}
        fedd={fedd}
      />
      <EmiTenureDialog
        closeEmiAlertDialog={closeEmiAlertDialog}
        openEmiAlertDialog={openEmiAlertDialog}
        suggestEmiValue={suggestEmiValue}
        suggestTenureValue={suggestTenureValue}
        handleEmiAlertDialogOk={handleEmiAlertDialogOk}
        dialogFor={dialogFor}
        currentValueHasError={currentValueHasError}
        revisedEMI={filterValues.revisedEmi}
      ></EmiTenureDialog>
      <ReSchedulementConfirmDialog
        openConfirmDialog={openConfirmDialog}
        clickCancel={closeSaveConfirmDialog}
        clickOK={handleSaveDialogOk}
        confirmMessage={confirmMessage}
        yesButtonDisableHandler={yesButtonDisableHandler}
        messageType={messageType}
      />

      <Dialog
        open={informationDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {informationDialogMsg}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!tenureAlertDlgMsgState && (
            <React.Fragment>
              <Tooltip title="Ctrl+Q" placement="top">
                <Button onClick={handleClose} ref={cancelRef}>
                  Cancel
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+Y" placement="top">
                <Button onClick={handleOk} ref={yesRef}>
                  Yes
                </Button>
              </Tooltip>
            </React.Fragment>
          )}
          {tenureAlertDlgMsgState && (
            <Tooltip title="Ctrl+K" placement="top">
              <Button onClick={handleOk} ref={okRef}>
                OK
              </Button>
            </Tooltip>
          )}
        </DialogActions>
      </Dialog>
      <CustomConfirmationDialog
        dialogOpen={accoutnCloseInformation}
        dialogTitle={
          <Typography sx={{ fontSize: "1.25rem" }}>Information</Typography>
        }
        dialogContent={
          <>
            <Typography sx={{ fontSize: "1rem" }}>
              The Corresponding Application Loan was already closed.
            </Typography>
          </>
        }
        hideCancelButton={true}
        okButtonName={"OK"}
        cancelButtonName={""}
        onOkClick={onOkButtonClick}
      />
    </>
  );
};
export default ReSchedulementPage;
